import SBModal from './sb.modal'

export default SBModal
